// extracted by mini-css-extract-plugin
export default {"portal":"portal__gJeUNcBVFpcp"};